var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 3.33203H3.33317C2.414 3.33203 1.6665 4.07953 1.6665 4.9987V14.9987C1.6665 15.9179 2.414 16.6654 3.33317 16.6654H16.6665C17.5857 16.6654 18.3332 15.9179 18.3332 14.9987V4.9987C18.3332 4.07953 17.5857 3.33203 16.6665 3.33203ZM16.6665 4.9987V5.42453L9.99984 10.6104L3.33317 5.42536V4.9987H16.6665ZM3.33317 14.9987V7.53536L9.48817 12.3229C9.6341 12.4375 9.81428 12.4998 9.99984 12.4998C10.1854 12.4998 10.3656 12.4375 10.5115 12.3229L16.6665 7.53536L16.6682 14.9987H3.33317Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default __webpack_public_path__ + "static/media/emails.c06cd9cf2d425328258a9455aa870eea.svg";
export { ForwardRef as ReactComponent };